module.exports = __webpack_public_path__ + "static/media/testing_05.b677cb2b.png";